import { useAuth0 } from '@auth0/auth0-react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    Drawer,
    Grid,
    IconButton,
    Paper,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    addDays,
    addMonths,
    addWeeks,
    differenceInDays,
    differenceInMonths,
    format,
    formatISO,
    getDay,
    getWeekOfMonth,
    isWeekend,
    lastDayOfMonth,
    lastDayOfYear,
    parseISO,
    setDay,
    setHours,
    startOfMonth,
    subMonths,
} from 'date-fns';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
    addAvailability,
    deleteAvailability,
    editAvailability,
} from '../../redux/AvailabilitySlice';
import SimpleSnackbar from '../SnackBar/SimpleSnackbar';
import sendNotification from '../../utils/sendNotification';
import CreateDaysInMonth from './DayComponent';
import EditAppointment from './EditAppointment';
import MakeAppt from './MakeAppt';
import ViewOnHold from './ViewOnHold';
import ViewPastAppointment from './ViewPastAppointment';
import ViewPastDate from './ViewPastDate';
import SignSchoolDocs from '../BasicComponents/SignSchoolDocs';

const MonthGrid = styled(Grid)(() => ({
    width: '100%',
    margin: 'auto',
    'z-index': 1,
    padding: '10px 10px 0',
    display: 'grid',
    'grid-gap': '2px',
    'align-content': 'stretch',
    'justify-content': 'stretch',
    'grid-template-columns':
        'minmax(30px, 1fr) minmax(150px, auto) minmax(30px, 1fr)',
}));

const WeekGrid = styled(Grid)(({ theme }) => ({
    width: '100%',
    margin: 'auto',
    'z-index': 1,
    padding: '10px 10px 0',
    display: 'grid',
    'grid-gap': '2px',
    'align-content': 'stretch',
    'justify-content': 'stretch',
    'grid-template-columns': 'repeat(7, minmax(30px, 1fr))',
}));

const DaysBox = styled(Box)(({ theme }) => ({
    padding: '8px 0px',
    textAlign: 'center',
    color: theme.palette.black.main,
    backgroundColor: theme.palette.white.main,
    borderColor: theme.palette.secondary.main,
    whiteSpace: 'nowrap',
}));

const CalendarArrow = styled(Box, {
    shouldForwardProp: prop => prop !== 'Left',
    name: 'CalendarArrow',
    slot: 'root',
    overridesResolver: (props, styles) => [
        styles.root,
        props.Left === true && styles.left,
        props.Left === false && styles.right,
    ],
})(({ theme }) => ({}));

const SideDrawer = styled(Box)(({ theme }) => ({
    backgroundColor: 'white',
    maxWidth: '600px',
}));

const StyledBox = styled(Box)(({ theme }) => ({
    padding: 0,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
}));

const RootDiv = styled('div')(({ theme }) => ({
    margin: 'auto',
    width: '100%',
    maxWidth: '1000px',
    '& > * + *': {
        marginTop: theme.spacing(2),
    },
    textAlign: 'center',
    padding: '30px 20px 40px',
}));

// const useStyles = makeStyles(theme => ({
//     // drawInside: {
//     //     padding: '16px',
//     // },
//     // drawer: {
//     //     // [theme.breakpoints.down('md')]: {
//     //     //     width: '350px',
//     //     // },
//     //     // [theme.breakpoints.up('sm')]: {
//     //     //     width: '600px',
//     //     // },
//     // },
//     // monthAndYear: {
//     //     // [theme.breakpoints.down('sm')]: {
//     //     //     fontSize: '15px',
//     //     // },
//     // },
// }));

const marks = [
    {
        value: 6,
        label: '6AM',
    },
    {
        value: 8,
        label: '8AM',
    },
    {
        value: 14,
        label: '2PM',
    },
    {
        value: 18,
        label: '6PM',
    },
    {
        value: 20,
        label: '10PM',
    },
];

//Made with the help of this tutorial https://programmingwithmosh.com/react/build-a-react-calendar-component-from-scratch/

const Calendar = props => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.profile.profile);

    // const classes = useStyles();
    const [state, setState] = useState({
        teacherProfile: {
            grade: '',
            address: '',
            teacherName: '',
            teacherProfile: '',
            skills: '',
            otherSkills: '',
            bio: '',
            addDates: '',
        },
        dateObject: Date.now(),
        allmonths: moment.months(),
        availabilities: [],
        data: [],
        editAppt: { time: [8, 17], startDate: formatISO(Date.now()) },
        openSnack: false,
        snackBarMessage: '',
        initialLoad: true,
    });
    const [loading, setLoading] = useState({ save: false, delete: false });
    const [snack, setSnack] = useState({
        open: false,
        message: '',
        severiy: 'success',
    });

    const [openAddDrawer, setOpenAddDrawer] = useState(false);
    const [openEditDrawer, setOpenEditDrawer] = useState(false);

    const [addAppt, setAddAppt] = useState({
        repeat: false,
        time: [8, 17],
        repeatValue: 0,
        date: formatISO(Date.now()),
    });

    const [editAppt, setEditAppt] = useState({
        time: [8, 17],
        date: formatISO(Date.now()),
    });

    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        if (profile.Data.Count > 0) {
            setState({
                ...state,
                teacherProfile: profile.Data.Items[0],
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile.Data.Count, profile.Data.Items]);

    useEffect(() => {
        if (props.myCalendar.availability.availability.Data.length > 0) {
            setState({
                ...state,
                initialLoad: false,
                data: props.myCalendar.availability.availability.Data,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.myCalendar.availability.availability.Data]);

    const toggleDrawer = (anchor, date, open, type, previous) => event => {
        if (open === false) {
            setOpenAddDrawer(false);
            setOpenEditDrawer(false);
        } else {
            if (
                event.type === 'keydown' &&
                (event.key === 'Tab' || event.key === 'Shift')
            ) {
                return;
            }
            let tempDate = addAppt;
            //When the side draw is closed the fields are re-initialised

            if (type === 'edit') {
                if (previous === true) {
                    let tempDate = {};
                    tempDate.sk1 = date.sk1;
                    tempDate.pk1 = date.pk1;
                    tempDate.startDate = date.startDate;
                    tempDate.endDate = date.endDate;
                    tempDate.status = `old${date.status}`;
                    let tempStartTime = format(parseISO(date.startDate), 'H');
                    let tempEndTime = format(parseISO(date.endDate), 'H');
                    tempDate.time = [tempStartTime, tempEndTime];
                    setOpenEditDrawer(true);
                    setEditAppt(tempDate);
                } else {
                    if (date.status === 'On Hold') {
                        let tempDate = {};
                        tempDate.sk1 = date.sk1;
                        tempDate.pk1 = date.pk1;
                        tempDate.startDate = date.startDate;
                        tempDate.endDate = date.endDate;
                        tempDate.status = date.status;
                        tempDate.bookingFlag = date.bookingFlag;
                        tempDate.bookedById = date.bookedById;
                        tempDate.uniqueId = date.uniqueId;
                        let tempStartTime = format(
                            parseISO(date.startDate),
                            'H'
                        );
                        let tempEndTime = format(parseISO(date.endDate), 'H');
                        tempDate.time = [tempStartTime, tempEndTime];

                        setOpenEditDrawer(true);
                        setEditAppt(tempDate);
                    } else if (
                        date.status === 'Confirmed' ||
                        date.status === 'Available'
                    ) {
                        let tempDate = {};
                        tempDate.sk1 = date.sk1;
                        tempDate.pk1 = date.pk1;
                        tempDate.startDate = date.startDate;
                        tempDate.endDate = date.endDate;
                        tempDate.status = date.status;
                        let tempStartTime = format(
                            parseISO(date.startDate),
                            'H'
                        );
                        let tempEndTime = format(parseISO(date.endDate), 'H');
                        tempDate.time = [tempStartTime, tempEndTime];
                        setOpenEditDrawer(true);
                        setEditAppt(tempDate);
                    }
                }
            } else {
                tempDate.date = formatISO(date);
                setOpenAddDrawer(true);
                setEditAppt(tempDate);
                setAddAppt({ ...addAppt, repeatValue: '0' });
            }
        }
    };

    const handleRepeatValueChange = event => {
        setAddAppt({ ...addAppt, repeatValue: event.target.value });
    };

    const handleSliderChange = event => {
        setAddAppt({ ...addAppt, time: event.target.value });
    };

    const handleEditSliderChange = event => {
        setEditAppt({ ...editAppt, time: event.target.value });
    };

    // useEffect(() => {
    //     console.log("Availability Count " + props.myCalendar.availability.availability.Data.length)
    //     if (props.myCalendar.availability.availability.Data.length > 0) {

    //     setState({
    //     ...state,
    //     data: props.myCalendar.availability.availability.Data
    //     });
    // }
    // }, [props.myCalendar.availability.availability.Data.length])

    const editAvail = async appointment => {
        setLoading({ ...loading, save: true });
        try {
            console.log('editSubmit', appointment);
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            appointment.startDate = formatISO(
                setHours(parseISO(appointment.startDate), appointment.time[0])
            );
            appointment.endDate = formatISO(
                setHours(parseISO(appointment.endDate), appointment.time[1])
            );
            let dynamoData = {
                token: token,
                request: {
                    sk1: appointment.sk1,
                    pk1: appointment.pk1,
                    startDate: appointment.startDate,
                    endDate: appointment.endDate,
                },
            };
            const outcome = await dispatch(editAvailability(dynamoData));
            console.log('edited outcome', outcome.payload.status);
            if (outcome.payload.status === 200) {
                // setSnack({
                //     message: 'Change successful',
                //     severity: 'success',
                //     open: true,
                // });
                // setTimeout(() => {
                //     setSnack({
                //         message: '',
                //         severity: 'success',
                //         open: false,
                //     });
                // }, 6000);
                sendNotification('success', 6000, 'Change successful');
            } else {
                // setSnack({
                //     message: 'Failed change availability time',
                //     severity: 'error',
                //     open: true,
                // });
                // setTimeout(() => {
                //     setSnack({
                //         message: '',
                //         severity: 'error',
                //         open: false,
                //     });
                // }, 6000);

                sendNotification(
                    'error',
                    6000,
                    'Failed change availability time'
                );
            }
            setOpenEditDrawer(false);
        } catch (err) {
            console.log('Error occurred editing availability');

            // setSnack({
            //     message: 'Cannot edit availability',
            //     severity: 'error',
            //     open: true,
            // });
            // setTimeout(() => {
            //     setSnack({
            //         message: '',
            //         severity: 'error',
            //         open: false,
            //     });
            // }, 6000);

            sendNotification('error', 6000, 'Cannot edit availability');
        } finally {
            setLoading({ ...loading, save: false });
        }
    };

    const deleteAvail = async appointment => {
        setLoading({ ...loading, delete: true });
        try {
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            let dynamoData = {
                token: token,
                request: {
                    items: [appointment.pk1 + '|' + appointment.sk1],
                },
            };

            const outcome = await dispatch(deleteAvailability(dynamoData));
            console.log('edited outcome', outcome.payload.status);
            if (outcome.payload.status === 200) {
                // setSnack({
                //     message: 'Deletion successful',
                //     severity: 'success',
                //     open: true,
                // });
                // setTimeout(() => {
                //     setSnack({
                //         message: '',
                //         severity: 'success',
                //         open: false,
                //     });
                // }, 6000);

                sendNotification('success', 6000, 'Deletion successful');
            } else {
                // setSnack({
                //     message: 'Cannot delete availability',
                //     severity: 'error',
                //     open: true,
                // });
                // setTimeout(() => {
                //     setSnack({
                //         message: '',
                //         severity: 'error',
                //         open: false,
                //     });
                // }, 6000);

                sendNotification('error', 6000, 'Cannot delete availability');
            }
            setOpenEditDrawer(false);
        } catch (err) {
            console.log('Error occurred deleting availability');
            // setSnack({
            //     message: 'Cannot delete availability',
            //     severity: 'error',
            //     open: true,
            // });
            // setTimeout(() => {
            //     setSnack({
            //         message: '',
            //         severity: 'error',
            //         open: false,
            //     });
            // }, 6000);

            sendNotification('error', 6000, 'Cannot delete availability');
        } finally {
            setLoading({ ...loading, delete: false });
        }
    };

    const addNewAvailability = async () => {
        setLoading({ ...loading, save: true });

        const appointment = addAppt;
        try {
            async function update(appointment) {
                let startDate = setHours(
                    parseISO(addAppt.date),
                    addAppt.time[0]
                );
                let endDate = setHours(parseISO(addAppt.date), addAppt.time[1]);

                const repeatDaysForYear =
                    differenceInDays(lastDayOfYear(startDate), startDate) - 1;
                let dateToSend = [];
                if (addAppt.repeatValue === '1') {
                    //repeat daily for the rest of the year
                    for (let i = 0; i < repeatDaysForYear; i++) {
                        dateToSend.push({
                            startDate: format(
                                startDate,
                                "yyyy-MM-dd'T'HH:mm:ss"
                            ),
                            endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss"),
                        });
                        startDate = addDays(startDate, 1);
                        endDate = addDays(endDate, 1);
                    }
                } else if (addAppt.repeatValue === '2') {
                    //repeat for every DAY for the rest of the year i.e. tuesday
                    for (let i = 0; i <= repeatDaysForYear; i = i + 7) {
                        dateToSend.push({
                            startDate: format(
                                startDate,
                                "yyyy-MM-dd'T'HH:mm:ss"
                            ),
                            endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss"),
                        });
                        startDate = addDays(startDate, 7);
                        endDate = addDays(endDate, 7);
                    }
                } else if (addAppt.repeatValue === '3') {
                    //repeat for every Nth day for the rest of the year
                    const repeatMonthsForYear =
                        differenceInMonths(
                            lastDayOfYear(startDate),
                            startDate
                        ) + 1;
                    const weekNumber = getWeekOfMonth(startDate, {
                        weekStartsOn: getDay(startOfMonth(startDate)),
                    });
                    const dayNumber = getDay(startDate);
                    for (let i = 0; i < repeatMonthsForYear; i++) {
                        const startOfMth = startOfMonth(startDate);
                        const startnthDay = setDay(startOfMth, dayNumber, {
                            weekStartsOn: getDay(startOfMth),
                        });
                        let startnthWeek = addWeeks(
                            startnthDay,
                            weekNumber - 1
                        );
                        const endnthDay = setDay(startOfMth, dayNumber, {
                            weekStartsOn: getDay(startOfMth),
                        });
                        let endnthWeek = addWeeks(endnthDay, weekNumber - 1);
                        startnthWeek = setHours(endnthWeek, addAppt.time[0]);
                        endnthWeek = setHours(endnthWeek, addAppt.time[1]);
                        dateToSend.push({
                            startDate: formatISO(startnthWeek),
                            endDate: formatISO(endnthWeek),
                        });
                        startDate = addMonths(startDate, 1);
                        endDate = addMonths(endDate, 1);
                    }
                } else if (addAppt.repeatValue === '4') {
                    //repeat daily for weekdays for the rest of the year
                    if (isWeekend(startDate)) {
                        dateToSend.push({
                            startDate: format(
                                startDate,
                                "yyyy-MM-dd'T'HH:mm:ss"
                            ),
                            endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss"),
                        });
                    } else {
                        for (let i = 0; i < repeatDaysForYear; i++) {
                            if (!isWeekend(startDate)) {
                                dateToSend.push({
                                    startDate: format(
                                        startDate,
                                        "yyyy-MM-dd'T'HH:mm:ss"
                                    ),
                                    endDate: format(
                                        endDate,
                                        "yyyy-MM-dd'T'HH:mm:ss"
                                    ),
                                });
                            }
                            startDate = addDays(startDate, 1);
                            endDate = addDays(endDate, 1);
                        }
                    }
                } else if (addAppt.repeatValue === '5') {
                    //repeat for every month for the rest of the year
                    const repeatMonthsForYear =
                        differenceInMonths(
                            lastDayOfYear(startDate),
                            startDate
                        ) + 1;
                    for (let i = 0; i < repeatMonthsForYear; i++) {
                        dateToSend.push({
                            startDate: format(
                                startDate,
                                "yyyy-MM-dd'T'HH:mm:ss"
                            ),
                            endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss"),
                        });
                        startDate = addMonths(startDate, 1);
                        endDate = addMonths(endDate, 1);
                    }
                } else if (addAppt.repeatValue === '6') {
                    //repeat for the rest of the week
                    if (isWeekend(startDate)) {
                        dateToSend.push({
                            startDate: format(
                                startDate,
                                "yyyy-MM-dd'T'HH:mm:ss"
                            ),
                            endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss"),
                        });
                    } else {
                        const repeatForWeek = 6 - getDay(startDate);
                        for (let i = 0; i < repeatForWeek; i++) {
                            dateToSend.push({
                                startDate: format(
                                    startDate,
                                    "yyyy-MM-dd'T'HH:mm:ss"
                                ),
                                endDate: format(
                                    endDate,
                                    "yyyy-MM-dd'T'HH:mm:ss"
                                ),
                            });
                            startDate = addDays(startDate, 1);
                            endDate = addDays(endDate, 1);
                        }
                    }
                } else if (addAppt.repeatValue === '7') {
                    //repeat for the rest of the month
                    if (isWeekend(startDate)) {
                        dateToSend.push({
                            startDate: format(
                                startDate,
                                "yyyy-MM-dd'T'HH:mm:ss"
                            ),
                            endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss"),
                        });
                    } else {
                        const repeatForMonth =
                            differenceInDays(
                                lastDayOfMonth(startDate),
                                startDate
                            ) + 2;
                        for (let i = 0; i < repeatForMonth; i++) {
                            if (!isWeekend(startDate)) {
                                dateToSend.push({
                                    startDate: format(
                                        startDate,
                                        "yyyy-MM-dd'T'HH:mm:ss"
                                    ),
                                    endDate: format(
                                        endDate,
                                        "yyyy-MM-dd'T'HH:mm:ss"
                                    ),
                                });
                            }
                            startDate = addDays(startDate, 1);
                            endDate = addDays(endDate, 1);
                        }
                    }
                } else {
                    //Do not repeat
                    dateToSend.push({
                        startDate: format(startDate, "yyyy-MM-dd'T'HH:mm:ss"),
                        endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss"),
                    });
                }

                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                let dynamoData = {
                    token: token,
                    request: {
                        grade: props.myCalendar.profile.profile.Data.Items[0]
                            .grades,
                        address:
                            props.myCalendar.profile.profile.Data.Items[0]
                                .address,
                        addDates: dateToSend,
                        lat: props.myCalendar.profile.profile.Data.Items[0].lat,
                        long: props.myCalendar.profile.profile.Data.Items[0]
                            .long,
                        type: props.myCalendar.profile.profile.Data.Items[0]
                            .type,
                        teacherName:
                            props.myCalendar.profile.profile.Data.Items[0].sk1,
                        teacherProfile:
                            props.myCalendar.profile.profile.Data.Items[0]
                                .profileImage,
                        skills: props.myCalendar.profile.profile.Data.Items[0]
                            .skills,
                        otherSkills:
                            props.myCalendar.profile.profile.Data.Items[0]
                                .otherSkills,
                        bio: props.myCalendar.profile.profile.Data.Items[0].bio,
                        repeat: addAppt.repeatValue,
                        status: 'Available',
                    },
                };
                console.log(
                    'Data to Send ' + JSON.stringify(dynamoData.request)
                );

                const outcome = await dispatch(addAvailability(dynamoData));
                console.log('edited outcome', outcome.payload);
                try {
                    if (outcome.payload.status === 200) {
                        // setSnack({
                        //     message: `Added ${outcome.payload.data.availability.length} new date(s) to your calendar`,
                        //     severity: 'success',
                        //     open: true,
                        // });
                        // setTimeout(() => {
                        //     setSnack({
                        //         message: '',
                        //         severity: 'success',
                        //         open: false,
                        //     });
                        // }, 6000);

                        sendNotification(
                            'success',
                            6000,
                            `Added ${outcome.payload.data.availability.length} new date(s) to your calendar`
                        );
                    } else {
                        // setSnack({
                        //     message:
                        //         'Failed to add available dates to your calendar',
                        //     severity: 'error',
                        //     open: true,
                        // });
                        // setTimeout(() => {
                        //     setSnack({
                        //         message: '',
                        //         severity: 'error',
                        //         open: false,
                        //     });
                        // }, 6000);
                        sendNotification(
                            'error',
                            6000,
                            'Failed to add available dates to your calendar'
                        );
                    }
                } catch (err) {
                    // setSnack({
                    //     message:
                    //         'Failed to add available dates to your calendar',
                    //     severity: 'error',
                    //     open: true,
                    // });
                    // setTimeout(() => {
                    //     setSnack({
                    //         message: '',
                    //         severity: 'error',
                    //         open: false,
                    //     });
                    // }, 6000);
                    sendNotification(
                        'error',
                        6000,
                        'Failed to add available dates to your calendar'
                    );
                }

                setOpenEditDrawer(false);
                setOpenAddDrawer(false);
            }
            update(appointment);
        } catch (err) {
            console.log('Error occurred adding availability');

            // setSnack({
            //     message: 'Cannot delete availability',
            //     severity: 'error',
            //     open: true,
            // });
            sendNotification('error', 6000, 'Cannot delete availability');
        } finally {
            setLoading({ ...loading, save: false });
        }
    };

    const renderHeader = () => {
        const dateFormat = 'MMMM yyyy';

        return (
            <MonthGrid container spacing={1} alignItems="center">
                <Grid item>
                    <StyledBox>
                        <CalendarArrow
                            Left={false}
                            onClick={prevMonth}
                            data-cy="calendarBackwardArrow"
                        >
                            <ArrowForwardIosIcon
                                style={{
                                    color: '#343a40',
                                    transform: 'scaleX(-1)',
                                    width: '0.75em',
                                    height: '0.75em',
                                    fontSize: '1.75em',
                                }}
                            ></ArrowForwardIosIcon>
                        </CalendarArrow>
                    </StyledBox>
                </Grid>
                <Grid item>
                    <StyledBox>
                        <Typography
                            sx={{
                                fontSize: '22px',
                                fontStyle: 'normal',
                                fontWeight: '500',
                                lineHeight: 'normal',
                                color: '#091747',
                            }}
                            data-cy="calendarMonthAndYear"
                        >
                            {format(state.dateObject, dateFormat)}
                        </Typography>
                    </StyledBox>
                </Grid>
                <Grid item>
                    <StyledBox>
                        <CalendarArrow
                            onClick={nextMonth}
                            Left={true}
                            data-cy="calendarForwardArrow"
                        >
                            <ArrowForwardIosIcon
                                style={{
                                    color: '#343a40',
                                    width: '0.75em',
                                    height: '0.75em',
                                    fontSize: '1.75em',
                                }}
                            ></ArrowForwardIosIcon>
                        </CalendarArrow>
                    </StyledBox>
                </Grid>
            </MonthGrid>
        );
    };

    const renderDays = () => {
        console.log('how many times are the days rendered?');

        return (
            <WeekGrid>
                <Grid item xs>
                    <DaysBox>S</DaysBox>
                </Grid>
                <Grid item xs>
                    <DaysBox>Mon</DaysBox>
                </Grid>
                <Grid item xs>
                    <DaysBox>Tue</DaysBox>
                </Grid>
                <Grid item xs>
                    <DaysBox>Wed</DaysBox>
                </Grid>
                <Grid item xs>
                    <DaysBox>Thu</DaysBox>
                </Grid>
                <Grid item xs>
                    <DaysBox>Fri</DaysBox>
                </Grid>
                <Grid item xs>
                    <DaysBox>S</DaysBox>
                </Grid>
            </WeekGrid>
        );

        // return <div className="days row">{days}</div>;
    };

    const nextMonth = () => {
        setState({
            ...state,
            dateObject: addMonths(state.dateObject, 1),
        });
    };

    const prevMonth = () => {
        setState({
            ...state,
            dateObject: subMonths(state.dateObject, 1),
        });
    };

    return (
        <RootDiv>
            <Paper sx={{ padding: '12px 0px' }}>
                <div>
                    <React.Fragment key={'left'}>
                        <Drawer
                            anchor="left"
                            open={openAddDrawer}
                            onClose={toggleDrawer(
                                'left',
                                Date.now(),
                                false,
                                'add'
                            )}
                        >
                            <SideDrawer data-cy="add-drawer">
                                <Box sx={{ m: 1 }}>
                                    <MakeAppt
                                        toggleDrawer={toggleDrawer}
                                        title="Add Work Hours"
                                        appt={addAppt}
                                        handleRepeatValueChange={
                                            handleRepeatValueChange
                                        }
                                        handleSliderChange={handleSliderChange}
                                        addNewAvailability={addNewAvailability}
                                        load={loading}
                                    />
                                </Box>
                            </SideDrawer>
                        </Drawer>
                    </React.Fragment>
                    <React.Fragment key={'right'}>
                        <Drawer
                            anchor="left"
                            open={openEditDrawer}
                            onClose={toggleDrawer(
                                'right',
                                editAppt,
                                false,
                                'edit'
                            )}
                        >
                            <SideDrawer data-cy="edit-drawer">
                                <Box sx={{ p: 1 }}>
                                    <IconButton
                                        color="secondary"
                                        onClick={toggleDrawer(
                                            'right',
                                            editAppt,
                                            false,
                                            'edit'
                                        )}
                                        data-cy="close-drawer"
                                    >
                                        <CloseIcon
                                            sx={{
                                                'z-index': 3,
                                                position: 'relative',
                                            }}
                                        />
                                    </IconButton>
                                    {
                                        {
                                            'Available': (
                                                <EditAppointment
                                                    editAppt={editAppt}
                                                    title="Edit Work Hours"
                                                    handleEditSliderChange={() =>
                                                        handleEditSliderChange
                                                    }
                                                    marks={marks}
                                                    deleteCallback={deleteAvail}
                                                    editCallback={editAvail}
                                                    load={loading}
                                                ></EditAppointment>
                                            ),
                                            'On Hold': (
                                                <ViewOnHold
                                                    title="Booking Pending"
                                                    booking={editAppt}
                                                />
                                            ),
                                            'Confirmed': (
                                                <ViewOnHold
                                                    title="Booking Pending"
                                                    booking={editAppt}
                                                />
                                            ),
                                            'oldConfirmed': (
                                                <ViewPastDate
                                                    title="Booking Pending"
                                                    booking={editAppt}
                                                />
                                            ),
                                            'oldOn Hold': (
                                                <ViewPastDate
                                                    title="Booking Pending"
                                                    booking={editAppt}
                                                />
                                            ),
                                            'oldAvailable': (
                                                <ViewPastAppointment
                                                    editAppt={editAppt}
                                                    title="View Availablity"
                                                    marks={marks}
                                                ></ViewPastAppointment>
                                            ),
                                        }[editAppt.status]
                                    }
                                </Box>
                            </SideDrawer>
                        </Drawer>
                    </React.Fragment>
                </div>
                {renderHeader()}
                {renderDays()}
                <CreateDaysInMonth
                    dateObject={state.dateObject}
                    data={state.data}
                    toggleDrawer={toggleDrawer}
                    disabled={props.disabled}
                />
            </Paper>

            <SimpleSnackbar
                message={snack.message}
                open={snack.open}
                severity={snack.severity}
            />
        </RootDiv>
    );
};

const mapStateToProps = state => ({
    myCalendar: state,
});

export default connect(mapStateToProps)(Calendar);
